import React from "react";
import { isEn, _t, i18n } from "app/i18n/i18n";
import { Button, Alert } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";
import { miscSlice } from "redux/slices/miscSlice";
import { useDispatch } from "react-redux";
import { auditRegisterToEvent } from "lib/analytics/auditEvents";

export function RegisterButton({ event }) {
  const dispatch = useDispatch();
  const onRegisterClick = () => dispatch(miscSlice.actions.set({ key: "showEventDetails", value: event }));
  return (
    <Button className="float-right" disabled={!event.canRegister} onClick={onRegisterClick}>
      <i className="far fa-calendar-check mr-2" />
      {event.canRegister ? _t("Click to register »") : _t("Registration unavailable")}
    </Button>
  );
}

export function WatchButton({ videoLink = "", buttonClassName }) {
  return (
    <a href={videoLink} alt="watch" target="_blank" rel="noopener noreferrer">
      <Button className={`float-right ${buttonClassName}`} variant="dark" disabled={!videoLink}>
        <i className="fas fa-video mr-2" />
        {videoLink ? _t("Watch recording »") : _t("Recording unavailable")}
      </Button>
    </a>
  );
}

export function Speakers({ speakers = [], className }) {
  const speakerNames = speakers.map((speaker) => speaker.name).join(", ");
  return (
    <small className={`text-primary font-weight-bold text-uppercase line-clamp-1  ${className}`} title={speakerNames}>
      {speakerNames}&nbsp;
    </small>
  );
}

export function FormattedEventDate({
  startDateFormatted,
  endDateFormatted,
  startTimeFormatted,
  endTimeFormatted,
  displayTime,
  fontClassName,
  breakDateAndTime,
}) {
  const isSameDate = startDateFormatted === endDateFormatted;

  const time = (
    <span>
      {startTimeFormatted} - {endTimeFormatted}
    </span>
  );

  return (
    <span className={fontClassName}>
      <span className="mr-2">{startDateFormatted}</span>
      {breakDateAndTime && <br />}
      {isSameDate ? (displayTime ? time : "") : `-  ${endDateFormatted}`}
    </span>
  );
}

export function NoEventsFound() {
  return (
    <Alert variant="warning mx-auto text-center center-block maxw-400 m-2">
      {isEn() && <Alert.Heading>{_t("No events found.")}</Alert.Heading>}
      <aside className="d-flex ">
        {_t("Sorry no events can be found matching the specified criteria.")}
        <FaIcon icon="far fa-times-circle fa-2x mr-2" />
      </aside>
    </Alert>
  );
}

export function Languages({ languages = [] }) {
  if (languages?.length === 0) return [];
  return languages.filter(
    (language) =>
      !(language === "English" && i18n.getLanguage() === "en") &&
      !(language === "Japanese" && i18n.getLanguage() === "ja"),
  );
}

export function RegisterButtonClick({ locationURL, buttonClassName, eventId }) {
  return (
    <a href={locationURL} alt="watch" target="_blank" rel="noopener noreferrer">
      <Button
        className={`float-right ${buttonClassName}`}
        variant="primary text-nowrap"
        disabled={!locationURL}
        title={_t("Registration information will be announced shortly")}
        onClick={() => {
          if (locationURL) {
            auditRegisterToEvent(eventId);
          }
        }}
      >
        {locationURL ? _t("Click to register »") : _t("Registration unavailable")}
      </Button>
    </a>
  );
}
